<script setup lang="ts">
import PageLabel from "components/common/PageLabel.vue";
import {TestService} from "@/api/api.ts";
import {ref} from "vue";
import {TestIndex} from "@/types";
import {ElNotification} from "element-plus";
import {useRouter} from "vue-router";
import TestStatisticCard from "components/test/TestStatisticCard.vue";

const router = useRouter();
const testIndex = ref<TestIndex>();

const getTestIndex = async () => {
  try {
    const res = await TestService.getTestIndex();
    if (res.data.code === 200) {
      testIndex.value = res.data.data
    } else {
      ElNotification.error({
        message: res.data.msg
      })
    }
  } catch (err) {
    console.warn(err)
  }
}

const toReelList = () => {
  router.push({
    name: "ReelList"
  })
}

const toTestList = () => {
  router.push({
    name: "TestList"
  })
}

getTestIndex();
</script>

<template>
  <div class="mx-3rem mt-2.25rem">
    <page-label>总览</page-label>
    <div class="flex gap-1.25rem" v-if="testIndex">
      <test-statistic-card title="已上传题目数" :value="testIndex.question_num" @click="toTestList" />
      <test-statistic-card title="已上传套卷数" :value="testIndex.reel_num" @click="toReelList" />
    </div>
  </div>
</template>

<style scoped>
.el-statistic {
  --el-statistic-content-font-size: 28px;
}
</style>
